'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _announcements = require('../actions/announcements');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchAnnouncements),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchAnnouncementsRequest);

function fetchAnnouncements() {
    var response;
    return regeneratorRuntime.wrap(function fetchAnnouncements$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/announcements');

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_announcements.actionCreators.fetchAnnouncementsSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_announcements.actionCreators.fetchAnnouncementsFailed());

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchAnnouncementsRequest() {
    return regeneratorRuntime.wrap(function fetchAnnouncementsRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_announcements.actionTypes.FETCH_ANNOUNCEMENTS_REQUEST, fetchAnnouncements);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

exports.default = [fetchAnnouncementsRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZWZmZWN0cy9hbm5vdW5jZW1lbnRzLmpzIl0sIm5hbWVzIjpbImZldGNoQW5ub3VuY2VtZW50cyIsImZldGNoQW5ub3VuY2VtZW50c1JlcXVlc3QiLCJyZXF1ZXN0IiwicmVzcG9uc2UiLCJhY3Rpb25DcmVhdG9ycyIsImZldGNoQW5ub3VuY2VtZW50c1N1Y2NlZWRlZCIsImRhdGEiLCJmZXRjaEFubm91bmNlbWVudHNGYWlsZWQiLCJhY3Rpb25UeXBlcyIsIkZFVENIX0FOTk9VTkNFTUVOVFNfUkVRVUVTVCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O0FBQ0E7O0FBQ0E7O21EQUVVQSxrQjtvREFXQUMseUI7O0FBWFYsU0FBVUQsa0JBQVY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLDJCQUcrQixtQkFBS0UsWUFBTCxFQUFjLEtBQWQsRUFBcUIsZ0JBQXJCLENBSC9COztBQUFBO0FBR2NDLDRCQUhkO0FBQUE7QUFBQSwyQkFLYyxrQkFBSUMsOEJBQWVDLDJCQUFmLENBQTJDRixTQUFTRyxJQUFwRCxDQUFKLENBTGQ7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBT2Msa0JBQUlGLDhCQUFlRyx3QkFBZixFQUFKLENBUGQ7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBV0EsU0FBVU4seUJBQVY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBQ1UseUJBQVdPLDJCQUFZQywyQkFBdkIsRUFBb0RULGtCQUFwRCxDQURWOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztrQkFJZSxDQUNYQyx5QkFEVyxDIiwiZmlsZSI6ImFubm91bmNlbWVudHMuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNhbGwsIHB1dCwgdGFrZUxhdGVzdCB9IGZyb20gJ3JlZHV4LXNhZ2EvZWZmZWN0cyc7XG5pbXBvcnQgeyBhY3Rpb25UeXBlcywgYWN0aW9uQ3JlYXRvcnMgfSBmcm9tICcuLi9hY3Rpb25zL2Fubm91bmNlbWVudHMnO1xuaW1wb3J0IHsgcmVxdWVzdCB9IGZyb20gJy4uL2FwaSc7XG5cbmZ1bmN0aW9uKiBmZXRjaEFubm91bmNlbWVudHMoKSB7XG5cbiAgICB0cnkge1xuICAgICAgICBjb25zdCByZXNwb25zZSA9IHlpZWxkIGNhbGwocmVxdWVzdCwgJ2dldCcsICcvYW5ub3VuY2VtZW50cycpO1xuXG4gICAgICAgIHlpZWxkIHB1dChhY3Rpb25DcmVhdG9ycy5mZXRjaEFubm91bmNlbWVudHNTdWNjZWVkZWQocmVzcG9uc2UuZGF0YSkpO1xuICAgIH0gY2F0Y2ggKGVycm9yKSB7XG4gICAgICAgIHlpZWxkIHB1dChhY3Rpb25DcmVhdG9ycy5mZXRjaEFubm91bmNlbWVudHNGYWlsZWQoKSk7XG4gICAgfVxufVxuXG5mdW5jdGlvbiogZmV0Y2hBbm5vdW5jZW1lbnRzUmVxdWVzdCgpIHtcbiAgICB5aWVsZCB0YWtlTGF0ZXN0KGFjdGlvblR5cGVzLkZFVENIX0FOTk9VTkNFTUVOVFNfUkVRVUVTVCwgZmV0Y2hBbm5vdW5jZW1lbnRzKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgW1xuICAgIGZldGNoQW5ub3VuY2VtZW50c1JlcXVlc3Rcbl07Il19


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/announcements.js
// module id = 2118
// module chunks = 0